// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PhoneSvg from '@rsuite/icon-font/lib/device/Phone';
var Phone = createSvgIcon({
  as: PhoneSvg,
  ariaLabel: 'phone',
  category: 'device',
  displayName: 'Phone'
});
export default Phone;